<template>
  <div class="centered-form">
    <form class="form">
      <div class="w-full flex justify-center">
        <img
          :src="logo"
          v-if="logo && $route.query.showNavigation === 'false'">
      </div>
      <div
        v-if="title"
        class="title">
        <h1>{{ title }}</h1>
      </div>
      <slot/>
    </form>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    props: [
      'title',
    ],
    computed: {
      ...mapGetters({
        logo: 'app/logo'
      })
    }
  }
</script>

<style lang="scss" scoped>
h1 {
  font-size: 2rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  font-weight: bold;
  text-align: center;
}
  .centered-form {
    @apply
    p-2
    flex
    md:p-0
    w-full
    h-full
    md:flex-col
    items-center
    text-gray-800
    justify-center;
    
    .form {
      @apply
      p-6
      h-auto
      w-full
      rounded
      md:border
      max-w-sm
      max-h-full
      md:shadow-lg
      overflow-y-auto
      bg-white;

      .title {
        @apply
        my-3
        text-xl
        font-medium;
      }
      
    }
  }
</style>